<div class="section-divider d-flex align-items-center gap-3 my-3">
  <div class="flex-grow-1 border-top"></div>
  <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">{{ 'STATISTIK_30_TAGE' | translate }}</span>
  <div class="flex-grow-1 border-top"></div>
</div>

<!-- ── Gesamtauswertung ── -->
<div *ngIf="stats.length > 0" class="mb-3">

  <!-- Jahres-Subtabs + Toggle -->
  <div class="d-flex flex-wrap align-items-center gap-1 mb-2">
    <button class="btn btn-sm" [ngClass]="globalYearFilter === 'all' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setGlobalYear('all')">{{ 'GLOBAL_GESAMT' | translate }}</button>
    <button *ngFor="let y of globalStatYears" class="btn btn-sm" [ngClass]="globalYearFilter === y ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setGlobalYear(y)">{{ y }}</button>
    <div class="position-relative ms-auto d-flex align-items-center gap-1 broken-data-wrap">
      <button class="btn btn-sm"
              [ngClass]="includeBrokenData ? 'btn-warning' : 'btn-outline-secondary'"
              (click)="includeBrokenData = !includeBrokenData">
        ⚠ broken data
      </button>
      <!-- Info button: mobile only (hover overlay shown on desktop via CSS) -->
      <button *ngIf="faultDays?.total! > 0" class="btn btn-sm btn-outline-secondary d-md-none"
              (click)="faultInfoOpen = true" style="padding:1px 6px;font-size:.75rem;" title="Fehltage">ⓘ</button>
      <div *ngIf="faultDays as fd" class="broken-data-overlay card shadow p-2">
        <!-- Summary (Inhalt der ehemaligen Fehltage-Card) -->
        <div class="d-flex align-items-center justify-content-between mb-1">
          <div style="font-size:.7rem;font-weight:600;text-transform:uppercase;"
               [class.text-warning]="fd.total > 0" [class.text-muted]="fd.total === 0">
            ⚠️ {{ 'FAULT_DAYS_LABEL' | translate }}
          </div>
          <div class="fw-bold ms-3" style="font-size:1rem;"
               [class.text-warning]="fd.total > 0" [class.text-muted]="fd.total === 0">
            {{ fd.total }} {{ 'AKKU_TAGE' | translate }}
          </div>
        </div>
        <ng-container *ngIf="fd.total === 0">
          <div class="text-muted" style="font-size:.75rem;">✓ {{ 'FAULT_DAYS_CLEAN' | translate }}</div>
        </ng-container>
        <ng-container *ngIf="fd.total > 0">
          <div class="d-flex flex-wrap gap-1 mb-2" style="font-size:.72rem;">
            <span *ngIf="fd.wifi   > 0" class="badge bg-warning text-dark" [title]="'FAULT_REASON.WIFI_OUTAGE' | translate">📶 {{ 'FAULT_TYPE_WIFI'   | translate }}: {{ fd.wifi }}</span>
            <span *ngIf="fd.freeze > 0" class="badge bg-warning text-dark" [title]="'FAULT_REASON.DEYE_FREEZE' | translate">❄️ {{ 'FAULT_TYPE_FREEZE' | translate }}: {{ fd.freeze }}</span>
            <span *ngIf="fd.tigo   > 0" class="badge bg-warning text-dark" [title]="'FAULT_REASON.TIGO_OUTAGE' | translate">☀️ {{ 'FAULT_TYPE_TIGO'   | translate }}: {{ fd.tigo }}</span>
            <span *ngIf="fd.noYield > 0" class="badge bg-warning text-dark" title="Kein PV-Ertrag während der Tageslichtzeit">🌑 kein Ertrag: {{ fd.noYield }}</span>
            <span *ngIf="fd.data   > 0" class="badge bg-secondary"          [title]="'FAULT_REASON.DATA_MISSING' | translate">📊 {{ 'FAULT_TYPE_DATA'   | translate }}: {{ fd.data }}</span>
          </div>
          <!-- Detail-Liste -->
          <div *ngFor="let d of faultDayList" class="d-flex justify-content-between align-items-start gap-2 py-1 border-top border-secondary-subtle">
            <span class="text-muted" style="white-space:nowrap;">{{ d.date | date:'dd.MM.yyyy' }}</span>
            <span class="text-end">
              <span class="badge"
                    [ngClass]="{
                      'bg-danger':            d.faultReason === 'WIFI_OUTAGE',
                      'bg-warning text-dark': d.faultReason === 'TIGO_OUTAGE',
                      'bg-primary':           d.faultReason === 'DEYE_FREEZE',
                      'bg-secondary':         d.faultReason === 'NO_YIELD' || d.faultReason === 'DATA_MISSING'
                    }">{{ d.faultReason }}</span>
              <span *ngIf="d.faultComment" class="text-muted ms-1" style="font-size:.68rem;">{{ d.faultComment }}</span>
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div *ngIf="globalStats as g">

    <!-- Zeitraum + Datenbasis -->
    <div class="text-center text-muted mb-2" style="font-size:.7rem;">
      <ng-container *ngIf="globalYearFilter === 'all'">{{ 'GLOBAL_DATEN_SEIT' | translate:{date: (g.since | date:'dd.MM.yyyy'), days: g.days} }}</ng-container>
      <ng-container *ngIf="globalYearFilter !== 'all'">{{ globalYearFilter }} · {{ g.since | date:'dd.MM.yyyy' }} – {{ g.until | date:'dd.MM.yyyy' }} · {{ g.days }} {{ 'AKKU_TAGE' | translate }}</ng-container>
      <span *ngIf="!includeBrokenData && g.totalDays > g.validDays" class="ms-2 text-warning">
        · {{ g.validDays }} / {{ g.totalDays }} {{ 'AKKU_TAGE' | translate }} valide
        ({{ g.totalDays - g.validDays }} fehlerhaft ausgeschlossen)
      </span>
      <span *ngIf="includeBrokenData && g.totalDays > g.validDays" class="ms-2 text-warning">
        · inkl. {{ g.totalDays - g.validDays }} fehlerhafte Tage
      </span>
    </div>

    <!-- Zeile 1: Energie -->
    <div class="row g-2 mb-2">
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100 border-warning">
          <div class="card-body p-2 text-center">
            <div class="text-warning" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">☀️ {{ 'GLOBAL_ERZEUGT' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.gen / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_GESAMT' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100 border-primary">
          <div class="card-body p-2 text-center">
            <div class="text-primary" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">🏠 {{ 'GLOBAL_VERBRAUCHT' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.cons / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_GESAMT' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100"
             [class.border-success]="g.autarkie >= 80"
             [class.border-warning]="g.autarkie >= 50 && g.autarkie < 80"
             [class.border-danger]="g.autarkie < 50">
          <div class="card-body p-2 text-center">
            <div style="font-size:.7rem;font-weight:600;text-transform:uppercase;"
                 [class.text-success]="g.autarkie >= 80"
                 [class.text-warning]="g.autarkie >= 50 && g.autarkie < 80"
                 [class.text-danger]="g.autarkie < 50">⚡ {{ 'COLS.AUTARKIE' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;"
                 [class.text-success]="g.autarkie >= 80"
                 [class.text-warning]="g.autarkie >= 50 && g.autarkie < 80"
                 [class.text-danger]="g.autarkie < 50">{{ Math.floor(p(g.autarkie)) }}%</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_EIGENVERSORGUNG' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100 border-danger">
          <div class="card-body p-2 text-center">
            <div class="text-danger" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">🔌 {{ 'NETZBEZUG' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.imp / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_VOM_NETZ' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100 border-success">
          <div class="card-body p-2 text-center">
            <div class="text-success" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">🌿 {{ 'GLOBAL_CO2' | translate }}</div>
            <div class="fw-bold mt-1 text-success" style="font-size:1.3rem;">{{ p(g.co2Saved).toFixed(2) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_TONNEN_CO2' | translate }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Zeile 2: Finanzen -->
    <div class="row g-2 mb-2">
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-info" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">💰 {{ 'GLOBAL_STROM_GESPART' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.savings).toFixed(0) }} €</div>
            <div class="text-muted" style="font-size:.7rem;">{{ ELECTRICITY_PRICE.toFixed(2) }} €/kWh</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-success" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">↑ {{ 'GLOBAL_EINSPEISUNG' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.feedinRevenue).toFixed(0) }} €</div>
            <div class="text-muted" style="font-size:.7rem;">{{ FEEDIN_TARIFF.toFixed(3) }} €/kWh · {{ p(g.exp / 1000).toFixed(1) }} MWh</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-muted" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">📊 {{ 'GLOBAL_GESAMTNUTZEN' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.totalBenefit).toFixed(0) }} €</div>
            <div class="text-muted" style="font-size:.7rem;">≈ {{ p(g.annualBenefit).toFixed(0) }} €/{{ 'GLOBAL_JAHR' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-muted" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">↑ {{ 'GLOBAL_EINGESPEIST' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.exp / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_INS_NETZ' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-muted" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">⚡ {{ 'GLOBAL_EIGENVERBRAUCH' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.selfConsumed / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_SELBST' | translate }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Amortisation (nur All-Time) -->
    <div *ngIf="globalYearFilter === 'all'" class="card mb-2">
      <div class="card-body p-2 p-sm-3">
        <div class="d-flex justify-content-between align-items-start mb-2">
          <div class="text-muted" style="font-size:.75rem;font-weight:600;text-transform:uppercase;">🏗️ {{ 'GLOBAL_AMORTISATION' | translate }}</div>
          <div class="text-end">
            <span class="fw-bold">{{ (g.amortisation ?? 0).toFixed(1) }}%</span>
            <span class="text-muted small ms-1">{{ 'GLOBAL_VON' | translate:{eur: SYSTEM_COST_EUR.toLocaleString('de-DE')} }}</span>
          </div>
        </div>
        <div class="progress" style="height:12px;border-radius:6px;">
          <div class="progress-bar"
               [class.bg-danger]="(g.amortisation ?? 0) < 30"
               [class.bg-warning]="(g.amortisation ?? 0) >= 30 && (g.amortisation ?? 0) < 70"
               [class.bg-success]="(g.amortisation ?? 0) >= 70"
               role="progressbar"
               [style.width.%]="(g.amortisation ?? 0) > 100 ? 100 : (g.amortisation ?? 0)">
          </div>
        </div>
        <div class="d-flex justify-content-between mt-1">
          <span class="text-muted" style="font-size:.7rem;">{{ p(g.totalBenefit).toFixed(0) }} € {{ 'GLOBAL_VON' | translate:{eur: SYSTEM_COST_EUR.toLocaleString('de-DE')} }}</span>
          <span *ngIf="g.paybackYears !== null" class="text-muted" style="font-size:.7rem;">
            ≈ {{ g.paybackYears.toFixed(1) }} {{ 'GLOBAL_JAHRE_BREAK_EVEN' | translate }}
          </span>
        </div>
      </div>
    </div>

    <!-- Annahmen -->
    <div class="text-muted text-center mt-1 mb-2" style="font-size:.65rem;">
      {{ 'GLOBAL_ANNAHMEN' | translate:{preis: ELECTRICITY_PRICE.toFixed(2), tarif: FEEDIN_TARIFF.toFixed(3), co2: CO2_FACTOR.toFixed(3)} }}
    </div>

  </div>
</div>

<!-- ── Verlauf ── -->
<div *ngIf="stats.length > 0">
  <div class="section-divider d-flex align-items-center gap-3 mb-2">
    <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
    <span class="small text-muted px-1">{{ 'GLOBAL_VERLAUF' | translate }}</span>
    <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
  </div>
  <div class="d-flex align-items-center gap-2 mb-2">
    <div *ngIf="statsView === 'daily'" class="d-flex flex-wrap gap-1">
      <button class="btn btn-sm" [ngClass]="statsMonthFilter === 'all' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="statsMonthFilter = 'all'">{{ 'ALLE' | translate }}</button>
      <button *ngFor="let m of statsMonths" class="btn btn-sm" [ngClass]="statsMonthFilter === m ? 'btn-secondary' : 'btn-outline-secondary'" (click)="statsMonthFilter = m"><span class="d-none d-sm-inline">{{ fmtMonth(m) }}</span><span class="d-sm-none">{{ fmtMonthShort(m) }}</span></button>
    </div>
    <div class="ms-auto btn-group btn-group-sm">
      <button class="btn" [ngClass]="statsView === 'daily' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="statsView = 'daily'">{{ 'GLOBAL_TAEGLICH' | translate }}</button>
      <button class="btn" [ngClass]="statsView === 'monthly' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="statsView = 'monthly'">{{ 'GLOBAL_MONATLICH' | translate }}</button>
    </div>
  </div>
  <ag-grid-angular
    *ngIf="statsView === 'daily'"
    [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
    [style.height.px]="statsGridHeight(filteredStats.length)"
    [rowData]="filteredStats"
    [columnDefs]="statsColDefs"
    [gridOptions]="statsGridOptions">
  </ag-grid-angular>
  <ag-grid-angular
    *ngIf="statsView === 'monthly'"
    [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
    [style.height.px]="statsGridHeight(monthlyStats.length)"
    [rowData]="monthlyStats"
    [columnDefs]="monthlyStatsColDefs"
    [gridOptions]="monthlyGridOptions">
  </ag-grid-angular>
</div>
<div *ngIf="stats.length === 0 && loading" class="mb-3">
  <div class="row g-2 mb-2">
    <div class="col-6 col-sm-4 col-lg" *ngFor="let _ of [0,1,2,3,4]">
      <div class="card h-100">
        <div class="card-body p-2 text-center">
          <app-skeleton width="70%" height=".7rem" radius="4px" [darkMode]="darkMode" style="display:block;margin:0 auto 8px;"></app-skeleton>
          <app-skeleton width="50%" height="1.5rem" radius="4px" [darkMode]="darkMode" style="display:block;margin:0 auto 6px;"></app-skeleton>
          <app-skeleton width="60%" height=".65rem" radius="4px" [darkMode]="darkMode" style="display:block;margin:0 auto;"></app-skeleton>
        </div>
      </div>
    </div>
  </div>
  <div class="row g-2">
    <div class="col-6 col-sm-4 col-lg" *ngFor="let _ of [0,1,2,3,4]">
      <div class="card h-100">
        <div class="card-body p-2 text-center">
          <app-skeleton width="70%" height=".7rem" radius="4px" [darkMode]="darkMode" style="display:block;margin:0 auto 8px;"></app-skeleton>
          <app-skeleton width="50%" height="1.5rem" radius="4px" [darkMode]="darkMode" style="display:block;margin:0 auto 6px;"></app-skeleton>
          <app-skeleton width="60%" height=".65rem" radius="4px" [darkMode]="darkMode" style="display:block;margin:0 auto;"></app-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="stats.length === 0 && !loading" class="text-muted small text-center py-2">{{ 'KEINE_DATEN' | translate }}</div>

<!-- ── Pellet-Statistik ── -->
<div *ngIf="pelletStats.length > 0" class="mt-3">
  <div class="section-divider d-flex align-items-center gap-3 mb-2">
    <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
    <span class="small text-muted px-1">🪵 {{ 'HEIZUNG_PELLET_STATISTIK' | translate }}</span>
    <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
  </div>

  <div class="d-flex align-items-center gap-2 mb-2">
    <div class="text-muted" style="font-size:.75rem;">
      {{ 'HEIZUNG_PELLET_GESAMT' | translate }}: <span class="fw-bold">{{ pelletTotalKg() | number:'1.0-0' }} kg</span>
    </div>
    <div class="ms-auto btn-group btn-group-sm">
      <button class="btn" [ngClass]="pelletStatsView === 'daily' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="pelletStatsView = 'daily'">{{ 'GLOBAL_TAEGLICH' | translate }}</button>
      <button class="btn" [ngClass]="pelletStatsView === 'monthly' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="pelletStatsView = 'monthly'">{{ 'GLOBAL_MONATLICH' | translate }}</button>
    </div>
  </div>

  <ag-grid-angular
    *ngIf="pelletStatsView === 'daily'"
    [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
    [style.height.px]="pelletGridHeight(pelletStats.length)"
    [rowData]="pelletStats"
    [columnDefs]="pelletColDefs"
    [gridOptions]="pelletGridOptions">
  </ag-grid-angular>
  <ag-grid-angular
    *ngIf="pelletStatsView === 'monthly'"
    [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
    [style.height.px]="pelletGridHeight(pelletMonthlyStats.length)"
    [rowData]="pelletMonthlyStats"
    [columnDefs]="pelletMonthlyColDefs"
    [gridOptions]="pelletGridOptions">
  </ag-grid-angular>
</div>

<!-- ── Fault days modal (mobile) ── -->
<ng-container *ngIf="faultInfoOpen">
  <div *ngIf="faultDays as fd"
       style="position:fixed;inset:0;z-index:1055;display:flex;align-items:flex-end;justify-content:center;background:rgba(0,0,0,0.5);"
       (click)="faultInfoOpen = false">
    <div class="bg-body shadow-lg w-100"
         style="border-radius:12px 12px 0 0;max-height:70vh;overflow-y:auto;padding:1rem;"
         (click)="$event.stopPropagation()">
      <div class="d-flex align-items-center mb-2">
        <span class="fw-semibold me-auto" style="font-size:.85rem;">⚠️ Fehltage</span>
        <button class="btn btn-sm btn-outline-secondary" (click)="faultInfoOpen = false">✕</button>
      </div>
      <div class="fw-bold mb-2" style="font-size:1.1rem;"
           [class.text-warning]="fd.total > 0" [class.text-muted]="fd.total === 0">
        {{ fd.total }} {{ 'AKKU_TAGE' | translate }}
      </div>
      <ng-container *ngIf="fd.total === 0">
        <div class="text-muted" style="font-size:.8rem;">✓ {{ 'FAULT_DAYS_CLEAN' | translate }}</div>
      </ng-container>
      <ng-container *ngIf="fd.total > 0">
        <div class="d-flex flex-wrap gap-1 mb-3" style="font-size:.75rem;">
          <span *ngIf="fd.wifi   > 0" class="badge bg-warning text-dark">📶 {{ 'FAULT_TYPE_WIFI'   | translate }}: {{ fd.wifi }}</span>
          <span *ngIf="fd.freeze > 0" class="badge bg-warning text-dark">❄️ {{ 'FAULT_TYPE_FREEZE' | translate }}: {{ fd.freeze }}</span>
          <span *ngIf="fd.tigo   > 0" class="badge bg-warning text-dark">☀️ {{ 'FAULT_TYPE_TIGO'   | translate }}: {{ fd.tigo }}</span>
          <span *ngIf="fd.noYield > 0" class="badge bg-warning text-dark">🌑 kein Ertrag: {{ fd.noYield }}</span>
          <span *ngIf="fd.data   > 0" class="badge bg-secondary">📊 {{ 'FAULT_TYPE_DATA'   | translate }}: {{ fd.data }}</span>
        </div>
        <div *ngFor="let d of faultDayList" class="d-flex justify-content-between align-items-start gap-2 py-2 border-top border-secondary-subtle">
          <span class="text-muted" style="white-space:nowrap;font-size:.8rem;">{{ d.date | date:'dd.MM.yyyy' }}</span>
          <span class="text-end">
            <span class="badge"
                  [ngClass]="{
                    'bg-danger':            d.faultReason === 'WIFI_OUTAGE',
                    'bg-warning text-dark': d.faultReason === 'TIGO_OUTAGE',
                    'bg-primary':           d.faultReason === 'DEYE_FREEZE',
                    'bg-secondary':         d.faultReason === 'NO_YIELD' || d.faultReason === 'DATA_MISSING'
                  }">{{ d.faultReason }}</span>
            <span *ngIf="d.faultComment" class="text-muted ms-1" style="font-size:.7rem;">{{ d.faultComment }}</span>
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>

<!-- ── Hourly chart overlay ── -->
<div *ngIf="hourlyDate"
     style="position:fixed;inset:0;z-index:1055;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.55);"
     (click)="closeHourly()">
  <div class="bg-body shadow-lg d-flex flex-column"
       style="width:min(96vw,900px);max-height:92vh;border-radius:8px;overflow:hidden;"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold me-auto">📊 {{ hourlyDate }}<span *ngIf="hourlyField" class="text-muted fw-normal"> · {{ hourlyFieldLabel(hourlyField) }}</span></span>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeHourly()">✕</button>
    </div>

    <!-- Body -->
    <div class="p-3 flex-grow-1 overflow-auto">

      <!-- Loading -->
      <div *ngIf="hourlyLoading" class="d-flex align-items-center justify-content-center" style="min-height:200px;">
        <div class="spinner-border text-secondary" role="status"></div>
      </div>

      <!-- Error -->
      <div *ngIf="hourlyError && !hourlyLoading" class="text-center text-muted py-5 small">
        ⚠ Stundendaten konnten nicht geladen werden.
      </div>

      <!-- Empty -->
      <div *ngIf="!hourlyLoading && !hourlyError && hourlyData.length === 0" class="text-center text-muted py-5 small">
        Keine Stundendaten verfügbar.
      </div>

      <!-- Chart -->
      <app-hourly-chart
        *ngIf="!hourlyLoading && !hourlyError && hourlyData.length > 0"
        [data]="hourlyData"
        [field]="hourlyField"
        [darkMode]="darkMode">
      </app-hourly-chart>

    </div>
  </div>
</div>
